let DataPage = {
    "data_site" : {},
};

let NotifyDataPage = {
    "data_site" : [],
}

export function SetListData(value) {
    DataPage = value;
    if(value["data_site"] && Array.isArray(value["data_site"])) {
        NotifyDataPage["data_site"].forEach(element => { element(value["data_site"]); });
    }
}

export function SetListDataSingle(key, value) {
    DataPage[key] = value;
    NotifyDataPage[key].forEach(element => {
        element(value);
    });
}

export function GetDataPage(key){
    return DataPage[key];
}

export function RegisterDataPage(key, value){
    if(!NotifyDataPage[key]){
        NotifyDataPage[key] = [];
    }
    NotifyDataPage[key].push(value);
}

export function UnRegisterDataPage(key, callback){
    if(NotifyDataPage[key].length > 0){
        NotifyDataPage[key] = NotifyDataPage[key].filter((item) => {
            return item !== callback;
        });
    }
}